import { ButtonHTMLAttributes } from "react";
import style from './SubscribeButton.module.scss';
import classNames from "classnames";

export const SubscribeButton = ({ className, children, ...props }: ButtonHTMLAttributes<HTMLInputElement>) => {
  return (<button className={classNames([style.button, className])} {...props}>{children}</button>);
}
